import React, { useMemo, useState } from 'react';
import { Button, Spin, message, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from '@apollo/client';
import {
  UPDATE_PARTNER,
  QUERY_PAYOUT_PLAN_LIST,
} from '~pages/dashboard/referral/partner-account/queries';

function AccountPayout({ country, partnerId, seletedPayoutPlanId, onClose }) {
  const { t } = useTranslation();
  const [payoutPlanId, setPayoutPlanId] = useState(seletedPayoutPlanId);

  const { loading: listPartnerPayoutPlansLoading, data: listPartnerPayoutPlansResponse } = useQuery(
    QUERY_PAYOUT_PLAN_LIST,
    {
      variables: {
        countryCode: country,
        pageNumber: 1,
        pageSize: 1000,
      },
    },
  );

  const payoutPlanList = useMemo(() => {
    return (
      listPartnerPayoutPlansResponse?.listPartnerPayoutPlans?.edges.map(edge => ({
        label: `${edge?.node?.name || ''}`,
        value: edge.node.id,
      })) || []
    );
  }, [listPartnerPayoutPlansResponse]);

  const [updatePartner, { loading: updatePartnerLoading }] = useMutation(UPDATE_PARTNER, {
    onError: e => {
      message.error(e.message);
    },
  });
  const handleSubmit = async () => {
    const response = await updatePartner({
      variables: {
        input: {
          id: partnerId,
          payoutPlanId: payoutPlanId,
        },
      },
    });
    if (response?.data?.updatePartner) {
      message.success('Update Partner Payout Plan Success');
      onClose();
    }
  };

  return (
    <>
      <div className="partner-register-city-editor__body" style={{ marginTop: '8px' }}>
        <section className="partner-register-city-editor__section">
          {listPartnerPayoutPlansLoading && !payoutPlanList.length ? (
            <div className="partner-register-city-editor__spin">
              <Spin />
            </div>
          ) : (
            <main className="partner-register-city-editor__main">
              <div className="">
                <h3 className="partner-account-selector-title">Payout Plan Name</h3>
                <Select
                  showSearch
                  className="partner-register-city-editor__selector"
                  onChange={value => {
                    setPayoutPlanId(value);
                  }}
                  value={payoutPlanId}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder={'Select Payout Plan'}
                >
                  {payoutPlanList.map(item => (
                    <Select.Option value={item.value}>{item.label}</Select.Option>
                  ))}
                </Select>
              </div>
              <If condition={payoutPlanId}>
                <PayoutPlanDescription
                  dataList={listPartnerPayoutPlansResponse?.listPartnerPayoutPlans?.edges}
                  seleted={payoutPlanId}
                />
              </If>
            </main>
          )}
        </section>
      </div>
      <div className="partner-register-city-editor__footer">
        <Button
          size="large"
          className="partner-register-city-editor__cancel-button"
          onClick={onClose}
        >
          {t('cms.referral.partner.detail.editor.btn.cancel')}
        </Button>
        <Button
          type="primary"
          size="large"
          htmlType="submit"
          className="partner-register-city-editor__save-button"
          loading={updatePartnerLoading}
          onClick={handleSubmit}
        >
          {t('cms.referral.partner.detail.editor.btn.save')}
        </Button>
      </div>
    </>
  );
}

const PayoutPlanDescription = ({ dataList, seleted }) => {
  const data = dataList?.find(item => item?.node?.id === seleted)?.node;

  return (
    <div className="partner-account-payoutplan">
      <div className="line">Applied Country: {data?.country?.name}</div>
      <div className="line">
        Percentage Paid after Opps Completed: {data?.bookingCompletedPercent}%
      </div>
      <div className="line">
        Percentage Paid after Landlord Commission Paid: {data?.bookingPaidPercent}%
      </div>
    </div>
  );
};

export default AccountPayout;
